module.exports = __webpack_public_path__ + "static/media/logoPutih.277d05f6.png";